// Visibility only: backend authorization remains required independently.
// Staging must opt in at build time and name one exact hostname (not a URL).
export function isConnectEnabled(hostname = typeof window === "undefined" ? "" : window.location.hostname) {
  const host = hostname.toLowerCase().replace(/\.$/, "");
  // Production workspace visibility is independent of staging and hosted browsers.
  if (["app.sporthouse.ai", "admin.sporthouse.ai"].includes(host)) {
    return process.env.REACT_APP_CONNECT_PRODUCTION_WORKSPACE_ENABLED === "true";
  }
  if (process.env.REACT_APP_CONNECT_ENABLED !== "true") return false;
  if (["localhost", "127.0.0.1", "[::1]"].includes(host)) return true;
  const stagingHost = process.env.REACT_APP_CONNECT_STAGING_HOST;
  return Boolean(stagingHost && hostname === stagingHost);
}
